import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()

export class IntegrationService {
	USER_URI: string = environment.apiUrl + '/userAccounts';

	constructor(private httpClient: HttpClient) {}

	public getAll = () => {
		return this.httpClient.get(this.USER_URI + '/');
	}

	public checkoutToken = (body) => {
		this.USER_URI=environment.apiUrl +'/pippedrive/consult-token';
		return this.httpClient.post(this.USER_URI  , body);
	}
}


// WEBPACK FOOTER //
// ./src/app/services/integration.service.ts